<template lang="html">
  <div class="container mb-2 card_box">
    <div class="row mb-3">
      <div
        v-if="beneficiaryId == 0 || isAllowForPreselectionChange"
        class="col-md-8 m-auto"
      >
        <SearchBar
          :loading-search="loadingSearch"
          :value-enter-search="valueEnterSearch"
          :beneficiary-auto-complete-list="
            beneficiaryAutoCompleteList
          "
          :text-value="searchText"
          @clickedOutside="hide"
          @textChanged="val => (searchText = val)"
          @itemSelected="
            item => onCharitySelectedFromAutoComplete(item)
          "
        />
      </div>
    </div>
    <!-- charity selected -->
    <div v-if="selectedCharity.beneficiaryId > 0">
      <div
        class="row w-100 m-auto justify-content-center"
        @click="removeBeneficiaryId"
      >
        <div
          class="beneficiary-small-margin"
          style="width:200px"
        >         
          <component 
            :is="componentToLoad"
            :beneficiary="selectedCharity.beneficiary"     
            :beneficiary-name="selectedCharity.beneficiaryName"
            :image-path="selectedCharity.beneficiaryImagePath"
            :component-settings="settings"
            is-selected
            :allow-deselection="beneficiaryId == 0 || isAllowForPreselectionChange"
            image-size="200px"
            min-width="210px"
          />
        </div>
      </div>
    </div>
    <div v-if="selectedCharity.beneficiaryId == 0">
      <!-- Tiered Charities -->
      <template v-if="tieredCharityList.length > 0">
        <div
          v-for="(tier, key) in tieredCharityList"
          :key="key"
          class="row text-center content-charity"
        >
          <template v-if="tier.charities && tier.charities.length > 0">
            <div
              v-if="tier.displayName && tier.displayName.length > 0"
              class="row w-100 mx-auto mt-3"
            >
              <div class="h3 col-12 text-center pb-4 tier-heading">
                {{ tier.displayName }}
              </div>
            </div>
            <div class="row w-100 m-auto justify-content-center">
              <div
                v-for="beneficiary in tier.charities"
                :key="beneficiary.BeneficiaryAccountId"
                class="wow bounceInUp mb-3"
                :class="
                  highestDisplayedTier == tier.displayName
                    ? 'beneficiary-small-margin'
                    : 'beneficiary-large-margin'
                "
                :style="
                  highestDisplayedTier == tier.displayName
                    ? 'width:200px'
                    : 'width:115px'
                "
                @click="
                  $_charityManagementMixin_stageCharity(
                    beneficiary
                  )
                "
              >
                <component 
                  :is="componentToLoad"
                  :beneficiary="beneficiary"                    
                  :beneficiary-name="beneficiary.BeneficiaryName"
                  :image-path="beneficiary.BeneficiaryImagePath" 
                  :component-settings="settings"
                  :image-size="
                    highestDisplayedTier == tier.displayName
                      ? '200px'
                      : '115px'
                  "
                  :min-width="
                    highestDisplayedTier == tier.displayName
                      ? '210px'
                      : '165px'
                  "
                />
              </div>
            </div>
          </template>
          <template v-else-if="containsTieredCharities && tieredCharityList.length == 0 && searchText.length > 0">
            <!-- eslint-disable vue/no-v-html -->
            <div
              class="col text-center alert alert-warning primary"
              v-html="getNoResultsText"
            />
          </template>
          <hr
            v-if="tier.charities && tier.charities.length > 0"
            class="w-100"
          >
        </div>
      </template>

      <!-- non tiered charities -->
      <div
        v-if="nonTieredCharityList.length > 0"
        class="row text-center content-charity"
      >
        <div
          v-if="containsTieredCharities"
          class="row w-100 mx-auto"
        >
          <div class="h3 col-12 text-center pb-4 tier-heading">
            {{ config.otherCharitiesTitle }}
          </div>
        </div>
        <div class="row w-100 m-auto justify-content-center mt-3">
          <div
            v-for="beneficiary in nonTieredCharityList"
            :key="beneficiary.beneficiaryId"
            class="beneficiary-large-margin"
            style="width:115px"
            @click="
              $_charityManagementMixin_stageCharity(beneficiary)
            "
          >
            <component 
              :is="componentToLoad"
              :beneficiary="beneficiary"
              :beneficiary-name="beneficiary.BeneficiaryName"
              :image-path="beneficiary.BeneficiaryImagePath"
              :component-settings="settings"
              image-size="115px"              
              min-width="165px"
            />
          </div>
        </div>
      </div>
      <div v-else-if="!containsTieredCharities && nonTieredCharityList.length == 0 && searchText.length > 0">
        <!-- eslint-disable vue/no-v-html -->
        <div
          class="col text-center alert alert-warning primary"
          v-html="getNoResultsText"
        />
      </div>  
      <div
        v-show="lazyLoading"
        class="lds-ring"
      >
        <div /><div /><div /><div />
      </div>
      
      <div class="row w-100">
        <div id="scroll-loader-charity" />
      </div>
    </div>
    <div
      v-show="alertMessageToDisplay.length > 0"
      class="row"
    >
      <AlertMessage
        :message="alertMessageToDisplay"
        @clicked="scrollToSearchBar"
      />
    </div>
    <div v-if="pagingSettings == constants.PAGING_SETTINGS.PAGED && ! lazyLoading">
      <Paginate 
        v-model="pageNumber"
        :page-count="totalPages"
        :click-handler="onPageChange"
        :container-class="'pagination justify-content-center'"
        prev-text="<"
        next-text=">"
      >
        <template #breakViewContent>
          ...
        </template>
      </Paginate>
    </div>  
  </div>
</template>

<script>
import SearchBar from "../SearchBar";
import AlertMessage from "../AlertMesage";
import gfComponents from "../components";
import Paginate from '../Paginate.vue';

const $ = require("jquery");
import tierManager from './tierManager';
import beneficiaryManager from './beneficiaryManager';
import constants from '../../common/constants';

export default {
    name: "CharityManagementMixin",
    components: { SearchBar, AlertMessage, Paginate },
    props: {
        eventCampaignId: {
            type: String,
            default: ""
        },
        beneficiaryId: {
            type: Number,
            default: 0
        },
        region: {
            type: String,
            default: ""
        },
        afterSelectCallBack: {
            type: String,
            default: ""
        },
        afterResetCallBack: {
            type: String,
            default: ""
        },
        external: {
            type: Object,
            default: () => {}
        },
        config: {
            type: Object,
            required: true,
            default: () => {}
        },
        tagIdsAsCsv: {
          type: String,
          default: ""
        },
        allowPreselectionChange: {
          type: Boolean,
          default: false
        },
        ignoreEventTiering: {
          type: Boolean,
          default: false
        },        
        pageSize: {
          type: Number,
          default: 25
        },
        mode: {
            type: Object,
            default: () => {}
        },
        showMoreResultsInfoText: {
          type: Boolean,
          default: true,
        },
        pagingSettings: {
          type: String,
          default: constants.PAGING_SETTINGS.INFINITE,
        },
    },
    data() {
        return {
            searchText: "",
            charityResults: [],
            pageNumber: 1,
            totalPages: 1,
            maxNumberOfPages: 5,
            defaultMaxResultsToDisplay : 1000,
            valueEnterSearch: false,
            lazyLoading: true,
            loadingSearch: false,
            availableTiers: [],
            cachedAvailableTiers: [],
            selectedCharity: {
                beneficiaryId: 0,
                beneficiaryImagePath: "",
                beneficiaryName: "",
                tags: []
            },
            stagedPreselectedBeneficiary: false,
            resetSearch: false,
            tierManager : new tierManager(),
            beneficiaryManager : new beneficiaryManager(),
            componentMode: '',
            gfComponents: gfComponents,
            settings : {},
            constants,
        };
    },

    computed: {
        componentToLoad() {
            if (!this.componentMode || this.componentMode == '')
                return null;

            return gfComponents.LoadComponent(this.componentMode);
        },
        alertMessageToDisplay() {
            if (!this.showMoreResultsInfoText || this.pagingSettings == this.constants.PAGING_SETTINGS.PAGED)
              return ''

            if (
                this.availableTiers.length > 0 &&
                this.containsTieredCharities &&
                this.searchText === ""
            )
                return this.config.tieredRefineSearchText;
            if (
                this.maxSearchResultsReached &&
                this.selectedCharity.beneficiaryId === 0
            )
                return this.config.tooManyResultsText;
            return "";
        },

        beneficiaryList: {
            get: function() {
                return this.charityResults;
            },
            set: function(value) {               
                if (value != null) {                    
                    this.charityResults = this.charityResults.concat(value);
                }
            }
        },

        highestDisplayedTier() {
            return this.tieredCharityList.filter(x => x.charities.length > 0)[0].displayName;            
        },

        maxSearchResultsReached() {
            return this.pageNumber >= this.maxNumberOfPages;
        },

        beneficiaryAutoCompleteList() {
            return this.beneficiaryList.slice(0, 7);
        },
        
        tieredCharityList() {            
            return this.tierManager.getTieredCharityList();
        },

        nonTieredCharityList() {            
            return this.tierManager.getNonTieredCharityList();
        },
        
        containsTieredCharities() {
            return (
                this.tieredCharityList
                    .map(x => x.charities)
                    .reduce((a, b) => a.concat(b)).length > 0
            );
        },

        isAllowForPreselectionChange() {
          return this.beneficiaryId > 0 && this.allowPreselectionChange;
        },

        isNotAllowedForPreselectionChange() {
          return this.beneficiaryId > 0 && !this.allowPreselectionChange;
        },

        getNoResultsText() {
          return this.config.noResultsText;
        }
    },

    watch: {
        searchText: async function(res) {
            this.configureLoadingCharitiesOnScroll();

            if(res !== '')
              await this.beneficiaryManager.performSearchForBeneficiaries(res, this.region, this.eventCampaignId, this.pageSize, this.tagIdsAsCsv);
            else
              this.loadList();
        },
        eventCampaignId() {
            this.$nextTick(async () => await this.doInitialLoad());
        },
        beneficiaryId() {
            this.$nextTick(async () => await this.doInitialLoad());
        }
    },
    
    created() {
        this.tierManager.configure(this);
        this.beneficiaryManager.configure(this);
        if(this.mode) {
          this.componentMode = this.mode.name;
          this.settings = this.mode.settings;
        }
    },

    async mounted() {        
        this.$gfLogger.logInfo("Mounted CharityManagementMixin");
        await this.doInitialLoad();        
    },

    methods: {
        async doInitialLoad() {
            if (this.eventCampaignId.length > 0) 
              await this.tierManager.getAvailableTiers(this.eventCampaignId);

            await this.loadList();
            Object.assign(this.cachedAvailableTiers, this.availableTiers);
        },

        loadList() {
            var self = this;
            self.lazyLoading = true;

            let params_query = {
                query: self.searchText,
                eventcampaignid: self.eventCampaignId,
                tags: [],                
                pagesize : self.pageSize
            };

            if (self.beneficiaryId > 0 &&  ! self.resetSearch)
                params_query.beneficiaryid = self.beneficiaryId;

            if (this._shouldLoadTieredLayout()) {
                self.loadBeneficiariesForTiers(params_query);
            } else {
              if (self.tagIdsAsCsv) {
                let tags = self.tagIdsAsCsv.split(',');
                params_query.tags = [...new Set(tags)].join(',');
              }
              self.beneficiaryManager.loadBeneficiaries(params_query);
            }
            params_query.tags = "";
            params_query = self.passParamsExternal(params_query);
            self.resetSearch = false;            
        },

        loadBeneficiariesForTiers(params_query){
          var self = this;

          self.availableTiers.forEach(tier => {
              if (tier.Type == constants.BENEFICIARY_TIER_TYPE && tier.Settings.length > 0) {                        
                  tier.Settings.forEach(setting => {
                      
                      if (setting.Entity.Type == constants.TAG_ENTITY_TYPE) {
                        if (self.tagIdsAsCsv) {
                          let tags = self.tagIdsAsCsv.split(',');
                          tags.push(setting.Entity.Value);
                          params_query.tags = [...new Set(tags)].join(',');
                        } else {
                          params_query.tags = setting.Entity.Value;
                        }
                        
                        self.beneficiaryManager.loadBeneficiariesForTiers(params_query, self.getMaxResultsToDisplay(setting.MaxResultsToDisplay));                        
                      }
                  });

                  self.pageNumber = self.pageNumber + 1;
                  
              } else {
                self.beneficiaryManager.loadBeneficiaries(params_query);
              }
          });
        },

        _shouldLoadTieredLayout(){
            return (this.availableTiers.length > 0 && !this.ignoreEventTiering)            
        },

        getMaxResultsToDisplay(maxResultsToDisplaySetting) {
            var result = this.defaultMaxResultsToDisplay;
            if(maxResultsToDisplaySetting !== "") {
                result = parseInt(maxResultsToDisplaySetting);
            }
            return result;
        },
        
        hide() {
            this.valueEnterSearch = false;
        },

        $_charityManagementMixin_stageCharity(beneficiary) {
            // override
        },

        onCharitySelectedFromAutoComplete(item) {
            this.$gfLogger.logInfo(
                "CharityManagementMixin.onCharitySelectedFromAutoComplete(), item: ",
                item
            );
            var self = this;
            self.valueEnterSearch = false;
            self.searchText = item.BeneficiaryName;
            self.charityResults = [item];
            self.$_charityManagementMixin_stageCharity(item);
        },

        passParamsExternal(params_query) {            
            if (this.external && this.external.id && this.external.type) {
                params_query.externalidtype = this.external.type;
                params_query.externalid = this.external.id;
            }
            if (this.region != "") {
                params_query.region = this.region;
            }
            return params_query;
        },

        configureLoadingCharitiesOnScroll() {
          if ((this._shouldLoadTieredLayout() && this.searchText ==='') || this.pagingSettings != this.constants.PAGING_SETTINGS.INFINITE) {  
              $(window).unbind('scroll');
              return;
          }

            var self = this;
            $(window).scroll(function() {
                if ($("#scroll-loader-charity")[0]) {
                    var hT = $("#scroll-loader-charity").offset().top,
                        hH = $("#scroll-loader-charity").outerHeight(),
                        wH = $(window).height(),
                        wS = $(this).scrollTop();
                    if (wS > hT + hH - wH) {
                        self.beneficiaryManager.getBeneficiariesLazyLoading();
                    }
                }
            });
        },

        removeBeneficiaryId() {
            if (this.isNotAllowedForPreselectionChange)
                return;

            if (this.allowPreselectionChange) {
              this.resetSearch = true;
              this.charityResults = [];
            }

            Object.assign(this.availableTiers, this.cachedAvailableTiers);
            this.searchText = "";
            this.selectedCharity.beneficiaryId = 0;
            this.beneficiaryImagePath = "";
            this.beneficiaryName = "";
            if (this.afterResetCallBack && this.afterResetCallBack !== "")
                window[this.afterResetCallBack](null);
            this.$emit("reset", null);

            this.$nextTick(async () => {
                if (this.eventCampaignId.length > 0) 
                  await this.tierManager.getAvailableTiers(this.eventCampaignId);
                this.loadList();
            });           
        },

        scrollToSearchBar() {
            $([document.documentElement, document.body]).animate(
                {
                    scrollTop: $("#vue-gf-beneficiary-search").offset().top - 20
                },
                1500
            );
        },

        onPageChange(page) {
          let params_query = {
              query: this.searchText,
              eventcampaignid: this.eventCampaignId,
              tags: [],                
              pagesize : this.pageSize,
              pageindex: page
          };

          this.lazyLoading = true;
          
          if (this.beneficiaryId > 0 &&  ! this.resetSearch)
                params_query.beneficiaryid = this.beneficiaryId;
          
          if (this.tagIdsAsCsv) {
            let tags = this.tagIdsAsCsv.split(',');
            params_query.tags = [...new Set(tags)].join(',');
          } 

          this.beneficiaryManager.loadBeneficiaries(params_query)

          params_query.tags = "";
          params_query = this.passParamsExternal(params_query);
          this.resetSearch = false;
        }
    }
};
</script>

<style scoped lang="css" src="../../assets/css/charity.css"></style>